import React, {useCallback} from 'react'
import AddOperator from '../../assets/icons/AddOperator'
import MultiplyOperator from '../../assets/icons/MultiplyOperator'
import SubtractOperator from '../../assets/icons/SubtractOperator'
import DivideOperator from '../../assets/icons/DivideOperator'
import ExponentOperator from '../../assets/icons/ExponentOperator'
import ReciprocalOperator from '../../assets/icons/ReciprocalOperator'
import {Box} from '@mui/material'
import {UltraSmallButton} from "../custom";

export type Props = {
    enabled: boolean,
    onClick: (operator: string) => void
}

const OperatorsPanel: React.FC<Props> = ({enabled, onClick}) => {
    const clickHandler = useCallback((type: string) => {
        enabled && onClick(type)
    }, [enabled, onClick])

    return <Box
        sx={{display: 'flex', opacity: enabled ? 1 : 0.3}}
    >
        <UltraSmallButton onClick={() => {
            clickHandler('+')
        }} data-event={'Expressions Add Operator Clicked'}><AddOperator/></UltraSmallButton>
        <UltraSmallButton onClick={() => {
            clickHandler('-')
        }} data-event={'Expressions Subtract Operator Clicked'}><SubtractOperator/></UltraSmallButton>
        <UltraSmallButton onClick={() => {
            clickHandler('*')
        }} data-event={'Expressions Multiply Operator Clicked'}><MultiplyOperator/></UltraSmallButton>
        <UltraSmallButton onClick={() => {
            clickHandler('/')
        }} data-event={'Expressions Divide Operator Clicked'}><DivideOperator/></UltraSmallButton>
        <UltraSmallButton onClick={() => {
            clickHandler('^')
        }} data-event={'Expressions Exponent Operator Clicked'}><ExponentOperator/></UltraSmallButton>
        <UltraSmallButton onClick={() => {
            clickHandler('1/')
        }} data-event={'Expressions Reciprocal Operator Clicked'}><ReciprocalOperator/></UltraSmallButton>
    </Box>
}

export default OperatorsPanel